import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-dryer',
  templateUrl: './air-dryer.component.html',
  styleUrls: ['./air-dryer.component.scss']
})
export class AirDryerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
